import { _api } from '@/utils/apiAxios';
import router from '@/router';
import { log } from '@/utils/logging';
import { linesHelper } from '@/utils/linesHelper';
const socket = require('@/utils/menuSignalR').socket;
let isTryToConnect = false;
let tryConnectInterval;
let isTryToGetChanges;

function getFirstLeagueId(menu) {
  if (!menu) return {};
  if (menu.league_id) {
    return menu;
  } else {
    return getFirstLeagueId(menu.children[0]);
  }
}

const state = {
  status: { loading: false },
  menuList: [],
  activeMenu: false,
  activeNav: {},
  activeCountry: 0,
  activeLeagueId: 0,
  menuLoading: false,
  activeDateRange: null,
};
const getters = {
  getLiveLineCount: (state, getters, rootState) => item => {
    var self = state;
    var count = 0;
    const allSportGroups = rootState.betLines.allsportGroup;
    if (self.activeMenu.icon !== 'live') return count;
    if (item.icon === 'all-sport') {
      self.activeMenu.children[0].children.map(a => {
        let distinctChildren = [...new Set(a.children.map(x => x.league_id))];
        distinctChildren.map(c => {
          allSportGroups
            .filter(d => d.league_id.includes(c))
            .map(l => {
              count += l.count;
            });
        });
      });
    } else {
      let distinctChildren = [...new Set(item.children.map(x => x.league_id))];
      distinctChildren.map(m => {
        allSportGroups
          .filter(d => d.league_id.includes(m))
          .map(l => {
            count += l.count;
          });
      });
    }

    return count;
  },
  isLive: state => state.activeMenu.icon === 'live',
};
const mutations = {
  initializing: state => {
    state.status = { loading: true };
  },
  setActiveCountry(state, data) {
    state.activeCountry = data;
  },
  setMenuList: (state, data) => {
    state.menuList = data.filter(menu => menu.children && menu.children.length <= 2 && menu.children.length !== 0);
  },
  setActiveMenu: (state, menu) => {
    (state.activeLeagueId = 0), (state.activeCountry = 0), (state.activeNav = {});
    state.activeMenu = menu;
  },
  setActiveLeague: (state, leagueId) => {
    state.activeLeagueId = leagueId;
    // router.push("/sports");
  },
  setActiveNav: (state, nav) => {
    state.activeNav = nav;
  },
  setMenuLoading: (state, data) => {
    state.menuLoading = data;
  },
  setActiveDateRange: (state, val) => {
    state.activeDateRange = val;
  },
};
const actions = {
  getMenuList: ({ commit, dispatch, rootState, state }) => {
    log('[SPORTSMENU] menu fetching');
    commit('initializing');
    const token = localStorage.getItem('epos_token');
    if (token) {
      // es-ES => use only "es" part because getmenu service accepts only first part
      let locale = rootState.settings.selectedLocale.short_code;
      _api
        .get(
          `/Navigation/getmenuv3?language=${locale}&brand=${rootState.settings.brandSettings.book_id}&menu_id=${rootState.settings.terminalInfo.menu_id}&withLiveCount=true&noCache=true`,
          { headers: { 'epos-token': token } },
        )
        .then(res => {
          commit('setMenuList', res.data.Data);
          let active;
          let url = window.location.pathname
            .split('/')
            .slice(2)
            .join('/');
          linesHelper.getActiveMenu('/' + url, state.menuList);
          console.log(state.activeMenu);
          if (!state.activeMenu) {
            active = res.data.Data.filter(r => r.icon === 'all-sport')[0];
            if (!active) {
              active = res.data.Data[1];
              active.icon = 'all-sport';
            }
          } else {
            active = state.activeMenu;
          }

          if (rootState.freeWagerStore.freeWagersViewing == false) {
            dispatch('setActiveMenu', active);
          }

          log('[SPORTSMENU] menu fetched');
          dispatch('connectMenuSocket');
        });
    }
  },
  connectMenuSocket: ({ commit, rootState, dispatch, state }) => {
    if (!rootState.settings.brandSettings.socket_is_active) return;
    if (state.browserIsIdle) return;
    if (socket.connectionStates.connected === rootState.settings.menuSocketConnection) {
      clearInterval(tryConnectInterval);
      isTryToConnect = false;
      return;
    }

    rootState.settings.menuSocketConnection = socket.connectionStates.connecting;
    socket._menuSocket
      .connect(() => {
        rootState.settings.menuSocketConnection = socket.connectionStates.disconnected;
        if (state.browserIsIdle) return;
      })
      .then(res => {
        log('[MENU] socket connected');
        socket._menuSocket.invoke('SubscribeToMenu', {
          MenuId: rootState.settings.terminalInfo.menu_id,
          BookId: rootState.settings.brandSettings.book_id,
        });
        clearInterval(tryConnectInterval);
        isTryToConnect = false;
        rootState.settings.menuSocketConnection = socket.connectionStates.connected;
        // listen to spesific line type for odds changes
        socket._menuSocket.subscribe('updateMenu', args => {
          if (
            args &&
            router.currentRoute.matched &&
            router.currentRoute.matched.length &&
            router.currentRoute.matched[0].name === 'sports'
          ) {
            dispatch('updateMenu');
          }
        });
      })
      .catch(err => {
        if (!isTryToConnect) {
          rootState.settings.menuSocketConnection = socket.connectionStates.disconnected;
          tryConnectInterval = setInterval(() => {
            if (
              router.currentRoute.matched &&
              router.currentRoute.matched.length &&
              router.currentRoute.matched[0].name === 'sports'
            ) {
              dispatch('updateMenu');
              dispatch('connectMenuSocket');
            }
          }, rootState.settings.brandSettings.socket_fail_interval);
          isTryToConnect = true;
          log('[MENU] socket connect failed');
        }
      });
  },
  updateMenu({ state, commit, dispatch, rootState }) {
    if (state.menuLoading) {
      return;
    }

    commit('setMenuLoading', true);
    const token = localStorage.getItem('epos_token');
    if (token) {
      // es-ES => use only "es" part because getmenu service accepts only first part
      let locale = rootState.settings.selectedLocale.short_code;
      _api
        .get(
          `/Navigation/getmenuv3?language=${locale}&brand=${rootState.settings.brandSettings.book_id}&menu_id=${rootState.settings.terminalInfo.menu_id}&withLiveCount=true&noCache=true`,
          { headers: { 'epos-token': token } },
        )
        .then(res => {
          commit('setMenuList', res.data.Data);
          dispatch('checkMenuChanges');
          commit('setMenuLoading', false);
        });
    }
  },
  checkMenuChanges({ commit, dispatch, rootState, state }) {
    let currentMenu = state.menuList;
    let menuVisible = linesHelper.menuIsVisible(currentMenu, state.activeNav.id);
    if (state.activeMenu.icon !== 'live') {
      if (menuVisible && linesHelper.menuHaveChanges(currentMenu, state.activeNav)) {
        let currentLeagueIds = linesHelper.getActiveMenu(
          '/' +
          state.activeNav.url
            .split('/')
            .slice(2)
            .join('/'),
          currentMenu,
        );
        commit('setActiveLeague', currentLeagueIds);
        dispatch('betLines/getLinesChanges', currentLeagueIds, { root: true });
        commit('betLines/hideFavorites', null, { root: true });
      } else if (!menuVisible) {
        router.replace('/sports');
        let currentLeagueIds = linesHelper.getActiveMenu('/', currentMenu);

        commit('setActiveLeague', currentLeagueIds);
        dispatch('betLines/getLinesChanges', currentLeagueIds, { root: true });
        commit('betLines/hideFavorites', null, { root: true });
      }
    }
  },
  setActiveMenu: ({ commit, dispatch, rootState, state }, menu) => {
    // Check if free wagering selected by user
    // Show exit modal for user, store selected menu in window object to use in FreeWagers component
    if (!menu) return;
    if (rootState.freeWagerStore.freeWagersViewing) {
      dispatch('freeWagerStore/tryGetFreeWagerLines', null, { root: true });
      if (rootState.betSlip.selections.size > 0) {
        commit('freeWagerStore/setShowExitFreeWageringModal', true, {
          root: true,
        });
        window.freeWagerTempMenu = menu;
        window.freeWagerNavigationType = 'MENU';
        return;
      }
    }
    commit('freeWagerStore/setFreeWagersViewing', false, { root: true });
    commit('setActiveMenu', menu);
    commit('betLines/hideFavorites', null, { root: true });
    let allMenu = null;
    let leagueIds = '';
    if (menu.fromSearch) {
      leagueIds = menu.children[0].league_id;
      allMenu = menu;
    } else {
      menu.children.map(item => {
        if (item.icon.toLowerCase() === 'featured') {
          item.children.map(all => {
            if (!!all.icon && (all.icon.toLowerCase() === 'all' || all.icon.toLowerCase() === 'all-sport')) {
              allMenu = all;
              leagueIds = all.league_id;
            }
          });
          if (!leagueIds && item.children.length) {
            leagueIds = item.children[0].league_id;
            allMenu = item.children[0];
          }
        }
      });
      if (!leagueIds && menu.icon !== 'live') {
        let firstLeagueId = getFirstLeagueId(menu.children.filter(item => item.icon.toLowerCase() === 'countries')[0]);
        allMenu = firstLeagueId;
        leagueIds = firstLeagueId.league_id;
      }
    }
    if (menu.icon === 'live') {
      dispatch('betLines/setLiveActiveTab', allMenu, { root: true });
    } else {
      let url = window.location.pathname
        .split('/')
        .slice(2)
        .join('/');
      let currentLeagueIds = linesHelper.getActiveMenu('/' + url, state.menuList);
      if (!currentLeagueIds) {
        rootState.betLines.betLineItems = []
        return;
      }

      commit('setActiveLeague', currentLeagueIds || leagueIds);
      dispatch('betLines/getBetLines', currentLeagueIds || leagueIds, {
        root: true,
      });
      commit('betLines/hideFavorites', null, { root: true });
    }
    window.scrollTo(0, 0);
  },
  setActiveLeague: ({ commit, dispatch, rootState }, leagueId) => {
    if (leagueId && leagueId[leagueId.length - 1] === ',') {
      leagueId = leagueId.slice(0, leagueId.length - 1);
    }
    // if (!leagueId) return;
    // Check if free wagering selected by user
    // Show exit modal for user, store selected leagueId in window object to use in FreeWagers component
    if (rootState.freeWagerStore.freeWagersViewing) {
      if (rootState.betSlip.selections.size > 0) {
        commit('freeWagerStore/setShowExitFreeWageringModal', true, {
          root: true,
        });
        window.freeWagerTempLeagueId = leagueId;
        window.freeWagerNavigationType = 'LEAGUE';
        return;
      }
    }

    commit('freeWagerStore/setFreeWagersViewing', false, { root: true });
    commit('setActiveLeague', leagueId);
    dispatch('betLines/getBetLines', leagueId, { root: true });
    commit('betLines/hideFavorites', null, { root: true });
  },
  setActiveNav: ({ commit }, nav) => {
    commit('setActiveNav', nav);
  },
  setActiveDateRange({ commit }, value) {
    commit("setActiveDateRange", value);
  }
};

export const sportMenu = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
